import { PeopleGroup } from './types/region-types';
import { fetchJoshuaProjectData, compareJoshuaProjectData } from './utils/joshua-project-api';

export { fetchJoshuaProjectData, compareJoshuaProjectData };
export type { PeopleGroup };

export const unreached_people_groups: PeopleGroup[] = [
  {
    id: "JP001",
    name: "Chiapas Maya",
    population: 850000,
    evangelical_percentage: 3.5,
    primary_religion: "Folk Catholicism",
    primary_language: "Maya",
    region_id: "CHIS"
  },
  {
    id: "JP002",
    name: "Huastec",
    population: 180000,
    evangelical_percentage: 1.2,
    primary_religion: "Folk Catholicism",
    primary_language: "Nahuatl",
    region_id: "HGO"
  },
  {
    id: "JP003",
    name: "Mazahua",
    population: 350000,
    evangelical_percentage: 2.8,
    primary_religion: "Folk Catholicism",
    primary_language: "Otomi",
    region_id: "HGO"
  },
  {
    id: "JP004",
    name: "Mixtec",
    population: 520000,
    evangelical_percentage: 4.3,
    primary_religion: "Folk Catholicism",
    primary_language: "Mixtec",
    region_id: "OAX"
  },
  {
    id: "JP005",
    name: "Nahuatl Northern Puebla",
    population: 240000,
    evangelical_percentage: 0.8,
    primary_religion: "Folk Catholicism",
    primary_language: "Nahuatl",
    region_id: "HGO"
  },
  {
    id: "JP006",
    name: "Tepehuan Southern",
    population: 30000,
    evangelical_percentage: 0.5,
    primary_religion: "Folk Catholicism",
    primary_language: "Spanish",
    region_id: "SIN"
  },
  {
    id: "JP007",
    name: "Zapotec Isthmus",
    population: 95000,
    evangelical_percentage: 1.7,
    primary_religion: "Folk Catholicism",
    primary_language: "Zapotec",
    region_id: "OAX"
  },
  {
    id: "JP008",
    name: "Yucateco Maya",
    population: 780000,
    evangelical_percentage: 5.2,
    primary_religion: "Folk Catholicism",
    primary_language: "Maya",
    region_id: "YUC"
  },
  {
    id: "JP009",
    name: "Totonac Highland",
    population: 200000,
    evangelical_percentage: 3.1,
    primary_religion: "Folk Catholicism",
    primary_language: "Totonac",
    region_id: "CHIS"
  },
  {
    id: "JP010",
    name: "Tarahumara",
    population: 75000,
    evangelical_percentage: 0.9,
    primary_religion: "Folk Catholicism",
    primary_language: "Spanish",
    region_id: "SIN"
  }
];

export const getUnreachedGroupsByRegion = (regionId: string): PeopleGroup[] => {
  return unreached_people_groups.filter(group => group.region_id === regionId);
};

export const getUnreachedPopulationByRegion = (regionId: string): number => {
  return unreached_people_groups
    .filter(group => group.region_id === regionId)
    .reduce((total, group) => total + group.population, 0);
};
